import * as React from "react";
import { useTheme } from "@mui/styles";
import PropTypes from "prop-types";

const Layout = ({ children, backgroundColor, width, height, styles, contentWidth="100%" }) => {
  const theme = useTheme();
  return (
    <>
      <div
        style={{
          backgroundColor: backgroundColor || theme.COLORS.BLUE.backgroundBlue,
          width: width,
          height: height,
          // overflowX: "hidden",
          ...styles,
        }}
      >
        <main style={{maxWidth: contentWidth,width:"100%"}}>{children}</main>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
